<template>
	<span :class="classNames">
		<FontAwesomeIcon :icon="jwCrownIcon" size="sm" />
		{{ $t('WEBAPP_FREEMIUM_TAG') }}
	</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { jwCrownIcon } from '@/plugins/global-fontawesome';

const props = withDefaults(
	defineProps<{
		size?: 'sm' | 'md' | 'lg';
	}>(),
	{
		size: 'sm',
	}
);

const classNames = computed(() => {
	return {
		'freemium-filter__badge': true,
		[`freemium-filter__badge--${props.size}`]: props.size,
	};
});
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

.freemium-filter__badge {
	display: inline-flex;
	align-items: center;
	font-size: 14px;
	line-height: 22px;
	letter-spacing: 0.2px;
	font-weight: bold;
	text-align: center;
	color: $jw-color-white;
	background: linear-gradient(-225deg, #5c6374 0%, #3b404e 31%, #272939 68%, #191d2a 100%);
	padding: 2px 7px;
	border-radius: 4px;
	margin-inline-start: 8px;

	&--sm {
		padding: 2px 6px;
		font-size: 12px;
		line-height: 16px;
	}

	svg {
		margin-inline-end: 8px;
	}
}
</style>
